// Create a new file for mail templates
import { leadVehicleEmail } from './leadVehicleEmail';
import { birthdayEmail } from './birthdayEmail';
import { truckAnniversaryEmail } from './truckAnniversaryEmail';
import { followUpEmail } from './followUpEmail';
import { leadLostEmail } from './leadLostEmail';

export const mailTemplates = {
  leadVehicleEmail,
  birthdayEmail,
  truckAnniversaryEmail,
  followUpEmail,
  leadLostEmail,
};
